import React from "react";

export interface FieldListColumn {
  label: string;
  width?: number | string;
  flex?: number;
}

interface FieldListHeaderProps {
  columns: FieldListColumn[];
  handleWidth?: number;
  actionWidth?: number;
  gap?: number;
}

const FieldListHeader: React.FC<FieldListHeaderProps> = ({
  columns,
  handleWidth,
  actionWidth,
  gap = 8,
}) => (
  <div className="u-w100 u-row" style={{ gap }}>
    {handleWidth != null && <div style={{ width: handleWidth, flexShrink: 0 }} />}
    {columns.map((col, i) => (
      <div
        key={i}
        className="bodytext-13 u-line-height-100 u-pl4"
        style={{
          flex: col.flex ?? (col.width ? undefined : 1),
          width: col.width,
          flexShrink: col.width ? 0 : undefined,
          minWidth: 0,
        }}
      >
        {col.label}
      </div>
    ))}
    {actionWidth != null && <div style={{ width: actionWidth, flexShrink: 0 }} />}
  </div>
);

export default FieldListHeader;
